import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';

export const EssayCard = ({ essay }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <Link
      to={`/essays/${essay.slug}`}
      className="group block"
      data-testid={`essay-card-${essay.slug}`}
    >
      <article className="py-6 sm:py-8 border-b border-[rgba(201,168,76,0.08)] transition-colors duration-300 group-hover:bg-[rgba(27,77,68,0.06)] -mx-4 px-4 sm:-mx-6 sm:px-6 rounded-lg">
        {/* Meta */}
        <div className="flex items-center gap-4 mb-3">
          <time className="font-['Inter'] text-xs text-[hsl(var(--silver))]">
            {formatDate(essay.published_at)}
          </time>
          {essay.reading_time && (
            <span className="font-['Inter'] text-xs text-[hsl(var(--muted-foreground))]">
              {essay.reading_time} min read
            </span>
          )}
        </div>

        {/* Title with underline animation */}
        <h3 className="font-['Cormorant_Garamond'] text-xl sm:text-2xl font-bold text-[hsl(var(--foreground))] mb-3 leading-[1.2] hover-underline inline">
          {essay.title}
        </h3>

        {/* Excerpt */}
        <p className="font-['Inter'] text-sm leading-[1.7] text-[hsl(var(--muted-foreground))] mt-3 line-clamp-2">
          {essay.excerpt}
        </p>

        {/* Tags */}
        {essay.tags?.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-4">
            {essay.tags.map(tag => (
              <Badge
                key={tag}
                variant="outline"
                className="font-['Inter'] text-[10px] font-medium uppercase tracking-[0.14em] border-[rgba(168,181,178,0.15)] text-[hsl(var(--silver))] bg-transparent px-2 py-0.5"
              >
                {tag}
              </Badge>
            ))}
          </div>
        )}
      </article>
    </Link>
  );
};
